import { render, staticRenderFns } from "./modalCopiarExame.vue?vue&type=template&id=41d35a4c"
import script from "./modalCopiarExame.vue?vue&type=script&lang=js"
export * from "./modalCopiarExame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports